/* globals window */
import moment from 'moment';
import getWorkoutStatusLabel from './getWorkoutStatusLabel';
import renderAddress from '../../../utils/renderAddress';
import trans from '../../../utils/trans';

/**
 * get the status of a workout
 * @return {String}
 */
const renderWorkoutStatus = (workout) => {
  const { isLoggedIn } = window.appSettings;
  const { spots_available: spotsAvailable, reserved, waitlist } = workout;
  const statusLabel = getWorkoutStatusLabel(workout);
  const labelModifier = isLoggedIn && !spotsAvailable && !reserved && !waitlist ? 'workout__details__status--red' : '';

  if (!statusLabel) {
    return '';
  }

  return `
      <div class="workout__details__status ${labelModifier}">
        ${statusLabel}
      </div>
    `;
};

/**
 * construct a template in case the workout has distance information
 * @return {String}
 */
const renderWorkoutDistance = () => '';
// FIXME this can only work if we have the users geolocation

// if (workout.location.distance_in_m) {
//   const distance = Math.round(workout.location.distance_in_m / 100) / 10;

//   return `
//     <br>
//     <span class="workout__details__type__distance">
//       ${distance} ${trans('classes.km')}
//     </span>
//   `;
// }

/**
 * construct a template for workout card
 * @return {String}
 */
const renderWorkoutCard = (workout) => {
  const { id, name, partner, location, till } = workout;
  const { locale } = window.appSettings;
  const url = `/${locale}/workouts/${id}/${workout.slug}`;
  const isDigital = workout.is_digital;
  let detailIcon = '';

  if (isDigital) {
    detailIcon = '<i class="icon icon_stream workout__details__icon"></i>';
  }

  return `
    <a class="workout" href="${url}" name="${id}" data-startTime="${moment(workout.from).format('HHmm')}" data-js-workout>
      <div class="workout__time">
        <div class="workout__time__start" content="${workout.from}">
          ${moment(workout.from).format('HH:mm')}
        </div>
        <div class="workout__time__duration">
          ${moment(till).diff(workout.from, 'minutes')} ${trans('classes.min')}
        </div>
      </div>
      <div class="workout__details">
        <div class="workout__details__header">
          ${detailIcon}

          <h2 class="workout__details__name">
            ${name}
          </h2>
        </div>
        <div class="workout__details__type">
          <div class="workout__details__type__location">
            ${partner.name}
          </div>
          <div class="workout__details__type__address">
            ${isDigital ? trans('classes.onlineWorkoutLabel') : renderAddress(location)}
          </div>
          ${renderWorkoutDistance(workout)}
        </div>
        ${renderWorkoutStatus(workout)}
      </div>
    </a>
  `;
};

export default renderWorkoutCard;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/inventoryOverview/utils/renderWorkoutCard.js